import { Controller } from "@hotwired/stimulus"

// accounts/signin — data-controller="accounts--signin"
export default class extends Controller {
  submit(event) {
    event.preventDefault()

    const form = event.target
    $(form).ajaxSubmit({
      dataType: "json",
      beforeSubmit: () => {
        $(".social-signin").hide()
        $("#login-waiter").show()
      },
      success: (response) => {
        if (response.redirect) {
          window.location = response.redirect
          return
        }

        $(".login-form-wrap").html(response.wrap)
        $("#login-waiter").hide()
        $(".social-signin").show()
        $("#user_login").focus()
      },
    })
  }
}
